import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { queueLength } from "./offlineQueue";
import { Capacitor } from "@capacitor/core";
import { App as CapApp } from "@capacitor/app";

const isElectron = navigator.userAgent.toLowerCase().includes("electron");
const isNative = Capacitor.isNativePlatform();

if (isNative) {
  // Several pages call raw axios/fetch with a relative "/api/..." path
  // instead of the shared api.js instance. That resolves correctly in the
  // browser (Nginx proxies /api on the same origin) but not inside
  // Capacitor, whose WebView origin (https://localhost) has no such proxy.
  // Rather than hunt down every call site, rewrite relative /api requests
  // to the real host at the transport level for native builds only.
  const API_HOST = process.env.REACT_APP_API_ENV === "production"
    ? "https://golfsocietymanager.com"
    : "https://staging.golfsocietymanager.com";

  axios.defaults.baseURL = API_HOST;

  const originalFetch = window.fetch.bind(window);
  window.fetch = (input, init) => {
    if (typeof input === "string" && input.startsWith("/api")) {
      return originalFetch(API_HOST + input, init);
    }
    return originalFetch(input, init);
  };
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Capacitor bundles the build into the app itself and serves it locally, so
// there's no network hop for the service worker's cache-first static-asset
// logic to short-circuit -- pure overhead, and a stale SW surviving a Play
// Store update could serve old cached assets over a freshly-installed APK.
// offlineQueue.js's offline score queueing is independent of the SW and
// works the same with or without it registered.
if ("serviceWorker" in navigator && !isElectron && !isNative) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then(reg => {
        const checkForUpdate = () => reg.update().catch(() => {});
        window.addEventListener("online", checkForUpdate);
        document.addEventListener("visibilitychange", () => {
          if (document.visibilityState === "visible") checkForUpdate();
        });

        let reloaded = false;
        const tryReload = () => {
          if (reloaded) return;
          if (queueLength() > 0) {
            // Don't yank the page out from under an in-progress offline sync
            // or an unsaved score entry — check back shortly instead.
            setTimeout(tryReload, 5000);
            return;
          }
          reloaded = true;
          window.location.reload();
        };
        navigator.serviceWorker.addEventListener("controllerchange", tryReload);
      })
      .catch(err => console.log("SW registration failed:", err));
  });
}

if (isNative) {
  // Android hardware back button has no default behavior in a pure web app.
  CapApp.addListener("backButton", () => {
    if (window.history.length > 1) window.history.back();
    else CapApp.exitApp();
  });
}

reportWebVitals();
